import { Reveal, Overline } from "@/components/site/Reveal";
import LeadDialog from "@/components/site/LeadDialog";
import { ASSETS, CALENDLY_URL } from "@/lib/content";
import { openCalendly } from "@/components/site/Calendly";
import { CalendarHeart } from "lucide-react";

export default function Connect() {
  return (
    <section
      id="connect"
      data-testid="connect"
      className="relative py-24 md:py-40 bg-muted/60 overflow-hidden"
    >
      <img
        src={ASSETS.clayTexture}
        alt=""
        aria-hidden
        className="pointer-events-none absolute -right-32 top-1/3 h-96 w-96 rounded-full object-cover opacity-20 blur-md"
      />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <Overline>Let's build the next step together</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif text-5xl md:text-7xl font-light leading-[0.95] tracking-tight">
              Growth rarely begins with having it all figured out.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-muted-foreground">
              It begins with the right conversation, a clearer direction, and the
              willingness to take one meaningful next step. Tell me where you are —
              I'd be honored to help you find a thoughtful path forward.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <div className="rounded-3xl border border-border bg-background p-8 md:p-10">
              <p className="font-serif text-2xl font-light">Start a conversation</p>
              <p className="mt-2 text-sm text-muted-foreground">
                Share a note and Joanne will personally follow up — or book a call
                directly.
              </p>
              <div className="mt-8 space-y-4">
                <button
                  data-testid="connect-book-call"
                  onClick={() => openCalendly(CALENDLY_URL)}
                  className="group flex w-full items-center justify-center gap-2 rounded-full bg-primary px-8 py-4 text-sm uppercase tracking-[0.18em] font-medium text-primary-foreground transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_-15px_rgba(193,119,103,0.6)]"
                >
                  <CalendarHeart className="h-4 w-4" strokeWidth={1.5} />
                  Book a Call
                </button>
                <LeadDialog
                  leadType="general"
                  overline="General inquiry"
                  title="Send Joanne a note"
                  description="Whatever you're navigating — leadership, business, or family — start here."
                  withMessage
                  messageLabel="How can I help?"
                  testId="general-contact"
                  trigger={
                    <button
                      data-testid="general-contact-trigger"
                      className="w-full rounded-full border border-foreground/25 px-8 py-4 text-sm uppercase tracking-[0.18em] font-medium transition-all duration-300 hover:border-primary hover:text-primary"
                    >
                      Send a Message
                    </button>
                  }
                />
                <LeadDialog
                  leadType="reading_support"
                  path="families"
                  overline="For Families"
                  title="Request reading support"
                  description="Share a little about your child and your reading concerns."
                  withMessage
                  messageLabel="About your child"
                  testId="reading-contact"
                  trigger={
                    <button
                      data-testid="reading-contact-trigger"
                      className="w-full rounded-full border border-foreground/25 px-8 py-4 text-sm uppercase tracking-[0.18em] font-medium transition-all duration-300 hover:border-primary hover:text-primary"
                    >
                      Reading Support Info
                    </button>
                  }
                />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
